import React from 'react';
import { connect } from 'react-redux'
import {
  IonRefresher,
  IonRefresherContent,
  withIonLifeCycle,
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonList,
  IonContent,
  IonHeader, IonPage, IonTitle, IonToolbar,
  IonIcon,
  IonLabel,
  IonSpinner,
  IonButton,
  IonPopover,
  IonButtons,
  IonMenuButton, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent
} from '@ionic/react';
import { fileTrayFullOutline, walletOutline, podiumOutline, cashOutline, ticketOutline, ellipsisVerticalOutline, serverOutline, cloudUploadOutline, cloudDownloadOutline, cart, checkmarkCircle, closeCircle, cubeOutline, ban } from 'ionicons/icons';
import './Home.css';
import PosActions from '../../actions/PosActions';
import MenuPrincipal from '../../components/menu/MenuPrincipal';
import { getCashRegister, getDominio, getLoginApp, getToken, getPermissions, getNewLogin, getEnabledModules } from '../../utils/functions';
import { initdb } from "../../data_base_local/dataservice";
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import UtilActions from '../../actions/UtilActions';

import {
  queryAllLocations,
  createLocationTest,
  queryAllPermisions,
  queryAllConfiguration,
  createConfiguration,
  getConfigurationById,
  updateConfigurationById,
  createPermission,
  createActivitie,
  queryAllProductsOffline,
  replaceAllProductsOfflineWithProgress,
  queryAllCustomersOffline,
  replaceAllCustomersOfflineWithProgress,
  queryAllOfflineInvoices,
  queryOfflineInvoiceById,
  queryOfflineInvoiceLines,
  markOfflineInvoiceSyncStatus,
  deleteOfflineInvoice,
  updateCustomerOfflineAfterSync
} from "../../data_base_local/dataservice";

type OfflineSyncMode = 'preventa' | 'cotizacion';

interface OfflineInvoiceSync {
  id: number;
  status_sync?: string;
  status_sale?: string;
  payload_json?: string;
}

interface OfflineInvoiceLineSync {
  qty: number;
  variation_id: number;
  product_id: number;
  discount_type: string;
  discount_amount: number;
  unit_price: number;
  unit_price_inc_tax: number;
  enable_stock: number;
  product_type: string;
  unit_id: number;
  dpp_inc_tax: number;
  line_json?: string;
}

interface IProps {
  get_: any;
  validate_permission_: any;
}

interface IState {
  dataPermissions: any;
  is_valid: any;
  data_login: any;
  permissionsUser: any;
  enabled_modules: any;
  data_default: any;
  is_syncing_server: boolean;
  sync_server_message: string;
  upload_sales_total: number;
  upload_sales_processed: number;
  is_downloading_offline_data: boolean;
  offline_data_message: string;
  download_products_total: number;
  download_products_saved: number;
  download_customers_total: number;
  download_customers_saved: number;
}

class Home extends React.Component<IProps, IState> {
  syncServerMessageTimer: ReturnType<typeof setTimeout> | null = null;
  offlineDataMessageTimer: ReturnType<typeof setTimeout> | null = null;
  downloadBeforeUnloadHandler = (event: BeforeUnloadEvent) => {
    if (!this.state.is_downloading_offline_data) {
      return;
    }

    event.preventDefault();
    event.returnValue = '';
  };

  constructor(props: any) {
    super(props)
    this.state = {
      dataPermissions: props.dataPermissions,
      is_valid: props.is_valid,
      data_login: props.data_login,
      permissionsUser: props.permissionsUser,
      enabled_modules: props.enabled_modules,
      data_default: props.data_default,
      is_syncing_server: false,
      sync_server_message: '',
      upload_sales_total: 0,
      upload_sales_processed: 0,
      is_downloading_offline_data: false,
      offline_data_message: '',
      download_products_total: 0,
      download_products_saved: 0,
      download_customers_total: 0,
      download_customers_saved: 0
    }

  }

  componentWillUnmount() {
    if (this.syncServerMessageTimer) {
      clearTimeout(this.syncServerMessageTimer);
      this.syncServerMessageTimer = null;
    }
    if (this.offlineDataMessageTimer) {
      clearTimeout(this.offlineDataMessageTimer);
      this.offlineDataMessageTimer = null;
    }
    window.removeEventListener('beforeunload', this.downloadBeforeUnloadHandler);
  }

  setSyncServerMessage(message: string) {
    this.setState({ sync_server_message: message });
    if (this.syncServerMessageTimer) {
      clearTimeout(this.syncServerMessageTimer);
      this.syncServerMessageTimer = null;
    }
    if (message) {
      this.syncServerMessageTimer = setTimeout(() => {
        this.setState({ sync_server_message: '' });
        this.syncServerMessageTimer = null;
      }, 5000);
    }
  }

  setOfflineDataMessage(message: string) {
    this.setState({ offline_data_message: message });
    if (this.offlineDataMessageTimer) {
      clearTimeout(this.offlineDataMessageTimer);
      this.offlineDataMessageTimer = null;
    }
    if (message) {
      this.offlineDataMessageTimer = setTimeout(() => {
        this.setState({ offline_data_message: '' });
        this.offlineDataMessageTimer = null;
      }, 5000);
    }
  }

  ionViewWillEnter() {
    this.componentDidMount();
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    this.setState({
      data_default: nextProps.data.data_default,
    });
    if (nextProps.data.data_default && nextProps.data.data_default.enabled_modules != this.state.enabled_modules) {
      this.ValidatePermissionAll();
    }

  }
  async componentDidMount() {

    this.props.get_({
      typeOption: 'get_data_default',
      user_id: getLoginApp().id,
    }, "api/get_data_default");

    this.props.get_({}, "api/get_pro");
    let data_login = getLoginApp();
    let token = getToken();
    let new_login = getNewLogin();

    initdb().catch(() => console.log("error sql"));

    if (Capacitor.isNativePlatform()) {

      let config = await getConfigurationById(1).then();
      if (config && config.values.length > 0) {
        let id_config = config.values[0].id;
        await updateConfigurationById(id_config, {
          token: getToken(),
          data_login: JSON.stringify(getLoginApp())
        }).then();

        //permisions
        let permisions = await getConfigurationById(2).then();
        if (permisions && permisions.values.length > 0) {
          let id_permisions = permisions.values[0].id;
          await updateConfigurationById(id_permisions, {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }).then();
        } else {
          let data = {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }
          await createConfiguration(data).then();
        }
      } else {
        let data = {
          token: token,
          data_login: JSON.stringify(data_login)
        }
        await createConfiguration(data).then();
        config = await getConfigurationById(1).then();
        //permisions
        let permisions = await getConfigurationById(2).then();
        if (permisions && permisions.values.length > 0) {
          let id_permisions = permisions.values[0].id;
          await updateConfigurationById(id_permisions, {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }).then();
        } else {
          let data = {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }
          await createConfiguration(data).then();
        }
      }

      //insertar logueo
      if (new_login == 1) {
        if (data_login) {
          //insertar deslogueo
          await createActivitie({
            log_name: moment().format('YYYY-MM-DD HH:mm:ss'),
            description: 'login',
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            user_id: data_login.id
          }).then();
          localStorage.removeItem('ari_app_new_login');
        }
      }
      this.setState({
        data_login: data_login
      });

      this.ValidatePermission();
    } else {
      if (data_login) {
        this.setState({
          data_login: data_login
        });
      }
    }
    this.ValidatePermissionAll();

  }

  /*necesario para validar permisos*/

  async ValidatePermission() {
    let dataPermissions: any = await queryAllPermisions().then();
    let is_valid = true;
    if (dataPermissions && dataPermissions.values.length > 0) {
      dataPermissions.values.map((val: any, key: any) => {
        if (val.status !== 'active') {
          is_valid = false;
        }
      });
      this.setState({ dataPermissions: dataPermissions.values, is_valid: is_valid });

    } else {
      this.setState({ dataPermissions: [], is_valid: false });
    }


    //alert(is_valid);
  };

  /* fin necesario para validar permisos*/
  ValidatePermissionAll() {
    let permissionsUser_temp = getPermissions();
    let enabled_modules_temp = getEnabledModules();

    this.setState({
      permissionsUser: permissionsUser_temp,
      enabled_modules: enabled_modules_temp
    });

  }

  handleRefresh(event: any) {

    setTimeout(() => {
      event.detail.complete();
    }, 2000);
    window.location.reload();
  }

  getBaseUrl() {
    const dominioRaw = typeof getDominio === 'function' ? getDominio() : '';
    const dominioValue = (dominioRaw ?? '').toString();
    const dominio: string[] = dominioValue.split('http');
    const storedDomain = window.localStorage.getItem('ari_app_dominio') || '';
    let url = '';

    if (!storedDomain) {
      return url;
    }

    if (dominio.length > 1) {
      url = storedDomain;
    } else {
      url = 'https://' + storedDomain;
    }

    return url;
  }

  getInvoiceKind(invoice: OfflineInvoiceSync): OfflineSyncMode {
    let payload: any = null;
    try {
      payload = invoice.payload_json ? JSON.parse(invoice.payload_json) : null;
    } catch (error) {
      payload = null;
    }

    const status = String(payload?.status || invoice.status_sale || '').toLowerCase();
    const typePreventa = Number(payload?.type_preventa || 0) === 1;
    if (typePreventa || status === 'draft') {
      return 'preventa';
    }

    return 'cotizacion';
  }

  buildSyncPayload(invoice: any, lines: OfflineInvoiceLineSync[], syncMode: OfflineSyncMode) {
    const parsedPayload = (() => {
      try {
        return invoice.payload_json ? JSON.parse(invoice.payload_json) : null;
      } catch (error) {
        return null;
      }
    })();

    const fallbackProducts = lines.map((line) => {
      const parsedLine = (() => {
        try {
          return line.line_json ? JSON.parse(line.line_json) : null;
        } catch (error) {
          return null;
        }
      })();

      if (parsedLine?.line_payload) {
        return parsedLine.line_payload;
      }

      return {
        quantity: Number(line.qty || 0),
        variation_id: line.variation_id,
        product_id: line.product_id,
        line_discount_type: line.discount_type || 'fixed',
        line_discount_amount: Number(line.discount_amount || 0),
        unit_price: Number(line.unit_price || 0),
        unit_price_inc_tax: Number(line.unit_price_inc_tax || 0),
        item_tax: 0,
        tax_id: null,
        tax_rate_id: null,
        enable_stock: Number(line.enable_stock || 0) === 1,
        product_type: line.product_type || 'single',
        base_unit_multiplier: 1,
        sub_unit_id: line.unit_id ?? 1,
        product_unit_id: line.unit_id ?? 1,
        dpp_inc_tax: Number(line.dpp_inc_tax || 0),
        unit_cost: Number(line.dpp_inc_tax || 0),
      };
    });

    const payload = parsedPayload || {
      user_id: getLoginApp()?.id ?? null,
      contact_id: invoice.contact_id,
      status: invoice.status_sale || 'quotation',
      is_quotation: 1,
      final_total: Number(invoice.total || 0),
      location_id: invoice.location_id ?? 1,
      additional_notes: invoice.notes || '',
      typeOption: 'saveOrder',
      action: 'create',
      products: fallbackProducts,
    };

    if (syncMode === 'preventa') {
      return {
        ...payload,
        status: 'draft',
        is_quotation: 0,
        type_preventa: 1,
      };
    }

    return {
      ...payload,
      status: 'quotation',
      is_quotation: 1,
      type_preventa: null,
      sub_status: 'quotation',
    };
  }

  async handleSyncToServer() {
    if (this.state.is_syncing_server) {
      return;
    }

    if (!navigator.onLine) {
      window.alert('Sin conexion a internet. Intente cuando haya internet.');
      return;
    }

    const baseUrl = this.getBaseUrl();
    if (!baseUrl) {
      window.alert('No se encontro el dominio de sincronizacion.');
      return;
    }

    this.setState({
      is_syncing_server: true,
      upload_sales_total: 0,
      upload_sales_processed: 0,
    });
    this.setSyncServerMessage('Sincronizando facturas offline al servidor...');

    try {
      await initdb();
      const token = getToken();

      const allInvoicesResult: any = await queryAllOfflineInvoices();
      const allInvoices = (allInvoicesResult?.values || []) as OfflineInvoiceSync[];
      const pendingInvoices = allInvoices.filter((invoice) => invoice.status_sync !== 'synced');

      this.setState({
        upload_sales_total: pendingInvoices.length,
        upload_sales_processed: 0,
      });

      if (pendingInvoices.length === 0) {
        this.setState({ is_syncing_server: false });
        this.setSyncServerMessage('No hay facturas offline pendientes para enviar.');
        return;
      }

      let ok = 0;
      let failed = 0;
      const syncModes: OfflineSyncMode[] = ['cotizacion', 'preventa'];

      for (const syncMode of syncModes) {
        const invoicesByMode = pendingInvoices.filter((invoice) => this.getInvoiceKind(invoice) === syncMode);
        if (invoicesByMode.length === 0) {
          continue;
        }

        for (const invoice of invoicesByMode) {
          await markOfflineInvoiceSyncStatus(invoice.id, 'syncing', `Enviando ${syncMode}...`, null, '');
        }

        const invoicesPayload: Array<{ local_id: number; sync_mode: OfflineSyncMode; payload: any }> = [];
        for (const invoice of invoicesByMode) {
          const invoiceResult: any = await queryOfflineInvoiceById(invoice.id);
          const linesResult: any = await queryOfflineInvoiceLines(invoice.id);
          const dbInvoice = (invoiceResult?.values || [])[0];
          const lines = (linesResult?.values || []) as OfflineInvoiceLineSync[];

          if (!dbInvoice) {
            continue;
          }

          invoicesPayload.push({
            local_id: invoice.id,
            sync_mode: syncMode,
            payload: this.buildSyncPayload(dbInvoice, lines, syncMode),
          });
        }

        if (invoicesPayload.length === 0) {
          continue;
        }

        const response = await fetch(`${baseUrl}/api/appapk/syncOfflineInvoices`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: 'Bearer ' + token } : {}),
          },
          body: JSON.stringify({
            sync_mode: syncMode,
            invoices: invoicesPayload,
          }),
        });

        const rawResponse = await response.text();
        let result: any = null;
        try {
          result = rawResponse ? JSON.parse(rawResponse) : null;
        } catch (error) {
          result = null;
        }

        if (!response.ok || !result) {
          failed += invoicesByMode.length;
          for (const invoice of invoicesByMode) {
            await markOfflineInvoiceSyncStatus(invoice.id, 'error', rawResponse || '', null, `HTTP ${response.status}`);
            this.setState((prevState) => ({
              upload_sales_processed: prevState.upload_sales_processed + 1,
            }));
          }
          continue;
        }

        const rows = Array.isArray(result?.results) ? result.results : [];
        const processedIds = new Set<number>();

        for (const row of rows) {
          const localId = Number(row?.local_id || 0);
          if (!localId) {
            continue;
          }
          processedIds.add(localId);

          if (Number(row?.success || 0) === 1) {
            ok += 1;
            const createdCustomer = row?.created_customer;
            if (createdCustomer && Number(createdCustomer?.local_customer_id || 0) > 0 && Number(createdCustomer?.contact_db_id || 0) > 0) {
              await updateCustomerOfflineAfterSync(
                Number(createdCustomer.local_customer_id),
                Number(createdCustomer.contact_db_id),
                String(createdCustomer.contact_id || '')
              );
            }
            await deleteOfflineInvoice(localId);
          } else {
            failed += 1;
            await markOfflineInvoiceSyncStatus(localId, 'error', JSON.stringify(row || {}), null, String(row?.msg || 'Error al sincronizar'));
          }

          this.setState((prevState) => ({
            upload_sales_processed: prevState.upload_sales_processed + 1,
          }));
        }

        for (const invoice of invoicesByMode) {
          if (!processedIds.has(invoice.id)) {
            failed += 1;
            await markOfflineInvoiceSyncStatus(invoice.id, 'error', '', null, `Sin respuesta para factura #${invoice.id}`);
            this.setState((prevState) => ({
              upload_sales_processed: prevState.upload_sales_processed + 1,
            }));
          }
        }
      }

      this.setState({
        is_syncing_server: false,
      });
      this.setSyncServerMessage(`Sincronizacion al server finalizada. Exitosas: ${ok} | Fallidas: ${failed}`);
    } catch (error: any) {
      this.setState({ is_syncing_server: false });
      this.setSyncServerMessage(`Error al sincronizar al server: ${error?.message || 'desconocido'}`);
    }
  }

  async handleDownloadOfflineData() {
    if (this.state.is_downloading_offline_data) {
      return;
    }

    if (!navigator.onLine) {
      window.alert('Sin conexion a internet. Intente cuando haya internet.');
      return;
    }

    const baseUrl = this.getBaseUrl();
    if (!baseUrl) {
      window.alert('No se encontro el dominio de sincronizacion.');
      return;
    }

    this.setState({
      is_downloading_offline_data: true,
      download_products_total: 0,
      download_products_saved: 0,
      download_customers_total: 0,
      download_customers_saved: 0,
      offline_data_message: 'Descargando productos y clientes...'
    });
    window.addEventListener('beforeunload', this.downloadBeforeUnloadHandler);

    try {
      await initdb();
      const dataLogin = getLoginApp() || {};
      const cashRegister = getCashRegister() || {};
      const token = getToken();
      const locationId = cashRegister.location_id ?? dataLogin.location_id ?? '';
      const priceGroup = dataLogin.selling_price_group_id ?? dataLogin.price_group_id ?? '';
      const user_id = dataLogin.id ?? '';

      const formData = new FormData();
      formData.append('user_id', String(user_id));

      if (locationId !== '') {
        formData.append('location_id', String(locationId));

      }
      if (priceGroup !== '') {
        formData.append('price_group', String(priceGroup));
      }
      formData.append('check_qty', '0');

      const productsResponse = await fetch(`${baseUrl}/api/appapk/getProductsOffline`, {
        method: 'POST',
        headers: {
          ...(token ? { Authorization: 'Bearer ' + token } : {}),
        },
        body: formData,
      });

      const productsRawResponse = await productsResponse.text();
      let productsResult: any = null;
      try {
        productsResult = productsRawResponse ? JSON.parse(productsRawResponse) : null;
      } catch (error) {
        productsResult = null;
      }

      if (!productsResponse.ok || !productsResult || !productsResult.success) {
        const backendMessage = productsResult?.msg || productsResult?.message || productsRawResponse || 'No se pudieron obtener los productos';
        throw new Error('Productos: HTTP ' + productsResponse.status + ' - ' + backendMessage);
      }

      const customersResponse = await fetch(`${baseUrl}/api/appapk/getCustomersOffline`, {
        method: 'POST',
        headers: {
          ...(token ? { Authorization: 'Bearer ' + token } : {}),
        },
        body: formData,
      });

      const customersRawResponse = await customersResponse.text();
      let customersResult: any = null;
      try {
        customersResult = customersRawResponse ? JSON.parse(customersRawResponse) : null;
      } catch (error) {
        customersResult = null;
      }

      if (!customersResponse.ok || !customersResult || !customersResult.success) {
        const backendMessage = customersResult?.msg || customersResult?.message || customersRawResponse || 'No se pudieron obtener los clientes';
        throw new Error('Clientes: HTTP ' + customersResponse.status + ' - ' + backendMessage);
      }

      const products = productsResult?.data || [];
      const customers = customersResult?.data || [];

      if (!Array.isArray(products) || !Array.isArray(customers)) {
        throw new Error('La respuesta no contiene listas validas de products/customers');
      }

      this.setState({
        download_products_total: products.length,
        download_products_saved: 0,
        download_customers_total: customers.length,
        download_customers_saved: 0,
        offline_data_message: `Almacenando productos (0/${products.length})...`
      });

      await replaceAllProductsOfflineWithProgress(products, (processed, total) => {
        this.setState({
          download_products_saved: processed,
          offline_data_message: `Almacenando productos (${processed}/${total})...`
        });
      });

      this.setState({
        offline_data_message: `Almacenando clientes (0/${customers.length})...`
      });

      await replaceAllCustomersOfflineWithProgress(customers, (processed, total) => {
        this.setState({
          download_customers_saved: processed,
          offline_data_message: `Almacenando clientes (${processed}/${total})...`
        });
      });

      const productsLocal: any = await queryAllProductsOffline();
      const customersLocal: any = await queryAllCustomersOffline();
      const productsCount = (productsLocal?.values || []).length;
      const customersCount = (customersLocal?.values || []).length;

      this.setOfflineDataMessage(`Descarga finalizada. Productos: ${productsCount} | Clientes: ${customersCount}`);
    } catch (error: any) {
      this.setOfflineDataMessage(`Error al descargar: ${error?.message || 'desconocido'}`);
    } finally {
      window.removeEventListener('beforeunload', this.downloadBeforeUnloadHandler);
      this.setState({ is_downloading_offline_data: false });
    }
  }

  render() {
    const {
      permissionsUser,
      dataPermissions,
      is_valid,
      data_login,
      enabled_modules,
      is_syncing_server,
      sync_server_message,
      upload_sales_total,
      upload_sales_processed,
      is_downloading_offline_data,
      offline_data_message,
      download_products_total,
      download_products_saved,
      download_customers_total,
      download_customers_saved,
    } = this.state;
    const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;
    console.log("permissionsUser", permissionsUser);
    // Validar si existe la propiedad access_own_sell_return en permissionsUser
    const hasAccessapp_view_customer_dues = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_customer_dues;

    const hasAccessapp_view_pos = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_pos;

    const hasAccessview_room_panel_module = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.view_room_panel_module;

    const module_rooms_enabled = enabled_modules && typeof enabled_modules === 'object'
      && !!enabled_modules['rooms'];

    const hasAccessapp_view_products = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_products;

    const hasAccessapp_view_expenses = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_expenses;

    const hasAccessapp_view_purchase = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_purchase;

    const hasAccessapp_view_registers = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_registers;

    const hasAccessapp_view_all_suspend = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_all_suspend;
    console.log("enabled_modules", enabled_modules, module_rooms_enabled);

    return (
      <>
        <MenuPrincipal />
        <IonPage id="main-content">
          <IonHeader className='ion-no-border'>
            <IonToolbar className='color-cyan'>
              <IonButtons slot="start" >
                <IonMenuButton autoHide={false}></IonMenuButton>
              </IonButtons>
              <IonTitle ></IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent fullscreen scrollEvents={true} className='background'>
            <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
              <IonRefresherContent></IonRefresherContent>
            </IonRefresher>
            <IonCardHeader className='color-cyan border-bottom-left-radius border-bottom-left-radius border-bottom-right-radius height-100 text-center padding-top-0'>
              <IonCardTitle className='text-bold'>ARI-TECH</IonCardTitle>
            </IonCardHeader>
            <IonGrid className='padding-top--70 padding-left-20 padding-right-20'>
              <IonRow align-items-center>


                {
                  !isOffline && (hasAccessapp_view_pos || (data_login && data_login.is_admin)) ?

                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#673ab7'}
                        className="height_card_buttom border-radius-shadow"
                        href="#/dashboard_pos/home"
                        style={{ borderRadius: "15px", background: "#673ab7", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={cart}
                            size="large"
                          />
                          <br />
                          <label>POS</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }

                {
                  !isOffline && (hasAccessapp_view_customer_dues || (data_login && data_login.is_admin)) ?

                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#673ab7'}
                        className="height_card_buttom border-radius-shadow"
                        href="#/customer_dues"
                        style={{ borderRadius: "15px", background: "#28bb50", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={cashOutline}
                            size="large"
                          />
                          <br />
                          <label>CUENTAS X COBRAR</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }
                
                {
                  (data_login && data_login.is_admin) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ffc509'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/backup"
                        style={{ borderRadius: "15px", background: "#ffc509", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={serverOutline}
                            size="large"
                          />
                          <br />
                          <label>BACKUP</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }




                <IonCol col-6 size='6'>
                  <IonButton
                    color={'#1565c0'}
                    className="height_card_buttom border-radius-shadow"
                    no-margin
                    href="#/pos_offline"
                    style={{ borderRadius: "15px", background: "#1565c0", borderColor: "#3f3d3d00" }}
                  >
                    <div>
                      <IonIcon
                        color="#ffffff"
                        slot="icon-only"
                        icon={cart}
                        size="large"
                      />
                      <br />
                      <label>POS OFFLINE</label>
                    </div>
                  </IonButton>
                </IonCol>

                <IonCol col-6 size='6'>
                  <IonButton
                    color={'#0369a1'}
                    className="height_card_buttom border-radius-shadow"
                    onClick={() => this.handleSyncToServer()}
                    disabled={is_syncing_server}
                    style={{ borderRadius: "15px", background: "#0369a1", borderColor: "#3f3d3d00" }}
                  >
                    <div>
                      <IonIcon
                        color="#ffffff"
                        slot="icon-only"
                        icon={cloudUploadOutline}
                        size="large"
                      />
                      <br />
                      <label>{is_syncing_server ? 'SINCRONIZANDO...' : 'SUBIR MIS VENTAS'}</label>
                    </div>
                  </IonButton>
                </IonCol>

                <IonCol col-6 size='6'>
                  <IonButton
                    color={'#1e8e5a'}
                    className="height_card_buttom border-radius-shadow"
                    onClick={() => this.handleDownloadOfflineData()}
                    disabled={is_downloading_offline_data}
                    style={{ borderRadius: "15px", background: "#1e8e5a", borderColor: "#3f3d3d00" }}
                  >
                    <div>
                      <IonIcon
                        color="#ffffff"
                        slot="icon-only"
                        icon={cloudDownloadOutline}
                        size="large"
                      />
                      <br />
                      <label>{is_downloading_offline_data ? 'DESCARGANDO...' : 'DESCARGAR BASE'}</label>
                    </div>
                  </IonButton>
                </IonCol>

                {sync_server_message ? (
                  <IonCol col-12 size='12' className='text-center'>
                    <IonLabel style={{ fontSize: '12px' }}>{sync_server_message}</IonLabel>
                  </IonCol>
                ) : null}

                {is_syncing_server ? (
                  <IonCol col-12 size='12' className='text-center'>
                    <IonLabel style={{ fontSize: '12px' }}>
                      Ventas subidas: {upload_sales_processed}/{upload_sales_total}
                    </IonLabel>
                  </IonCol>
                ) : null}

                {offline_data_message ? (
                  <IonCol col-12 size='12' className='text-center'>
                    <IonLabel style={{ fontSize: '12px' }}>{offline_data_message}</IonLabel>
                  </IonCol>
                ) : null}

                {is_downloading_offline_data ? (
                  <IonCol col-12 size='12' className='text-center'>
                    <IonLabel style={{ fontSize: '12px', display: 'block' }}>
                      Productos almacenados: {download_products_saved}/{download_products_total}
                    </IonLabel>
                    <IonLabel style={{ fontSize: '12px', display: 'block' }}>
                      Clientes almacenados: {download_customers_saved}/{download_customers_total}
                    </IonLabel>
                  </IonCol>
                ) : null}

                {
                  !isOffline && ((enabled_modules && enabled_modules['rooms'] && hasAccessview_room_panel_module) || (data_login && data_login.is_admin && (enabled_modules && enabled_modules['rooms']))) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ffc509'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/rooms"
                        style={{ borderRadius: "15px", background: "#3F51B5", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={serverOutline}
                            size="large"
                          />
                          <br />
                          <label>HABITACIONES</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }

                {
                  !isOffline && (hasAccessapp_view_products || (data_login && data_login.is_admin)) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ef4bbbff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/dashboard_products/listProducts"
                        style={{ borderRadius: "15px", background: "#ef4bbbff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={cubeOutline}
                            size="large"
                          />
                          <br />
                          <label>PRODUCTOS</label>
                        </div>
                      </IonButton>
                    </IonCol> : null


                }

                {
                  !isOffline && (hasAccessapp_view_expenses || (data_login && data_login.is_admin)) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ef4b4bff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/dashboard_gastos/listGastos"
                        style={{ borderRadius: "15px", background: "#ef4b4bff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={podiumOutline}
                            size="large"
                          />
                          <br />
                          <label>GASTOS</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }

                {
                  !isOffline && (hasAccessapp_view_purchase || (data_login && data_login.is_admin)) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ef4b4bff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/purchases"
                        style={{ borderRadius: "15px", background: "#0d66e3ff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={walletOutline}
                            size="large"
                          />
                          <br />
                          <label>COMPRAS</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }
                {
                  !isOffline && (hasAccessapp_view_registers || (data_login && data_login.is_admin)) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#425a07ff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/cajas"
                        style={{ borderRadius: "15px", background: "#425a07ff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={fileTrayFullOutline}
                            size="large"
                          />
                          <br />
                          <label>CAJAS</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }

                {
                  !isOffline && (hasAccessapp_view_all_suspend || (data_login && data_login.is_admin)) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'rgb(82, 14, 14)'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/orders_suspends"
                        style={{ borderRadius: "15px", background: "rgb(82, 14, 14)", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={ban}
                            size="large"
                          />
                          <br />
                          <label>SUSPENDIDAS</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }


              </IonRow>
            </IonGrid>
            <IonRow align-items-center>
              <IonCol col-12 size='12' className='text-center'>
                <IonCardTitle className='text-bold'>Permisos Necesarios</IonCardTitle>
              </IonCol>
              {
                !is_valid ?
                  <IonCol col-12 size='12' className='text-center'>
                    <IonCardTitle className='text-bold'>(*) Necesita tener todos los permisos activos para usar POS</IonCardTitle>
                  </IonCol> : null
              }
              <IonCol col-12 size='12' >
                <IonList inset={true}>
                  {dataPermissions && dataPermissions.length > 0 && dataPermissions.map((val: any, key: any) => {
                    return (
                      <IonItem key={key}>
                        <IonLabel>{
                          val.name == 'android.permission.WAKE_LOCK' ? 'Bloqueo de Activación' :
                            val.name == 'android.permission.FOREGROUND_SERVICE' ? 'Servicio en Segundo Plano' :
                              val.name == 'android.permission.ACCESS_COARSE_LOCATION' ? 'Ubicación' :
                                val.name == 'android.permission.ACCESS_FINE_LOCATION' ? 'Ubicación precisa' :
                                  val.name == 'android.permission.POST_NOTIFICATIONS' ? 'Notificaciones' :
                                    val.name
                        }</IonLabel>
                        <IonIcon
                          slot="end"
                          icon={val.status === 'active' ? checkmarkCircle : closeCircle}
                          color={val.status === 'active' ? 'success' : 'danger'}
                        />
                      </IonItem>
                    );
                  })}
                  {(!dataPermissions || dataPermissions.length === 0) && (
                    <IonItem className='text-center'>
                      <IonLabel>Si ya dio Permisos y no aparece la lista reinicie la app</IonLabel>
                    </IonItem>
                  )}
                </IonList>
              </IonCol>
            </IonRow>

            {is_syncing_server ? (
              <div className='offline-download-overlay'>
                <div className='offline-download-overlay-card'>
                  <IonSpinner name='crescent' />
                  <IonLabel className='offline-download-overlay-title'>Subiendo ventas al servidor...</IonLabel>
                  <IonLabel className='offline-download-overlay-line'>
                    Ventas subidas: {upload_sales_processed}/{upload_sales_total}
                  </IonLabel>
                  <IonLabel className='offline-download-overlay-hint'>No cierres ni cambies de pantalla.</IonLabel>
                </div>
              </div>
            ) : null}

            {is_downloading_offline_data ? (
              <div className='offline-download-overlay'>
                <div className='offline-download-overlay-card'>
                  <IonSpinner name='crescent' />
                  <IonLabel className='offline-download-overlay-title'>Guardando base offline...</IonLabel>
                  <IonLabel className='offline-download-overlay-line'>
                    Productos: {download_products_saved}/{download_products_total}
                  </IonLabel>
                  <IonLabel className='offline-download-overlay-line'>
                    Clientes: {download_customers_saved}/{download_customers_total}
                  </IonLabel>
                  <IonLabel className='offline-download-overlay-hint'>No cierres ni cambies de pantalla.</IonLabel>
                </div>
              </div>
            ) : null}
          </IonContent>
        </IonPage >
      </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
    validate_permission_: () => dispatch(UtilActions.validate_permission_()),
  }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps)(Home));
